/**
 * Formats account age based on creation date
 * Returns format: "X years Y months" or "X months Y days" or "X days"
 */
export function formatAccountAge(createdDateTime: Date | string | null): string {
  if (!createdDateTime) {
    return 'N/A';
  }

  const created = new Date(createdDateTime);
  const now = new Date();

  if (isNaN(created.getTime())) {
    return 'N/A';
  }

  const diffMs = now.getTime() - created.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return 'N/A';
  }

  if (diffDays < 30) {
    return diffDays === 1 ? '1 day' : `${diffDays} days`;
  }

  const years = Math.floor(diffDays / 365);
  const remainingDaysAfterYears = diffDays % 365;
  const months = Math.floor(remainingDaysAfterYears / 30);

  if (years > 0) {
    if (months > 0) {
      return `${years} ${years === 1 ? 'year' : 'years'} ${months} ${months === 1 ? 'month' : 'months'}`;
    }
    return `${years} ${years === 1 ? 'year' : 'years'}`;
  }

  if (months > 0) {
    const daysInMonth = diffDays % 30;
    if (daysInMonth > 0) {
      return `${months} ${months === 1 ? 'month' : 'months'} ${daysInMonth} ${daysInMonth === 1 ? 'day' : 'days'}`;
    }
    return `${months} ${months === 1 ? 'month' : 'months'}`;
  }

  return `${diffDays} days`;
}
